<script>
export default {
  props: {
    sort: { type: String, required: true },
    sortDirection: { type: String, required: true },
    shippers: { type: Array, required: true },
    selectedShipper: { default: null },
    installers: { type: Array, required: true },
    selectedInstaller: { default: null },
    showCompleted: { type: Boolean, required: true },
    selectedView: { type: String, required: true },
    viewOptions: { type: Array, required: true },
  },
  methods: {
    updateProp(name, value) {
      this.$emit(`update:${name}`, value);
    },
  },
};
</script>

<template>
  <div class="flex-wrap align-items-stretch justify-content-center">
    <div class="sort-buttons d-flex flex-row justify-content-around">
      <b-button @click="$emit('sort-delivery-date')" size="sm" class="flex-grow-1 mx-1 " variant="outline-primary" :pressed="sort == 'deliveryDate'">
        <i class="mdi mdi-chevron-down mdi-18px align-middle"
          v-if="sortDirection == 'desc' && sort == 'deliveryDate'"></i>
        <i class="mdi mdi-chevron-up mdi-18px align-middle"
          v-if="sortDirection == 'asc' && sort == 'deliveryDate'"></i>{{ $t("general.deliverydate") }}
      </b-button>
      <b-button @click="$emit('sort-installation-date')" size="sm" class="flex-grow-1 mx-1 " variant="outline-primary" :pressed="sort == 'installationDate'">
        <i class="mdi mdi-chevron-down mdi-18px align-middle"
          v-if="sortDirection == 'desc' && sort == 'installationDate'"></i>
        <i class="mdi mdi-chevron-up mdi-18px align-middle"
          v-if="sortDirection == 'asc' && sort == 'installationDate'"></i>{{ $t("general.installationdate") }}
      </b-button>
    </div>
    <div class="filter-cta d-flex flex-wrap">
      <div class="d-flex align-items-center justify-content-between ">
        <b-form-select :value="selectedShipper" @input="updateProp('selectedShipper', $event)" v-if="shippers.length > 2" :options="shippers"
          class=""></b-form-select>
      </div>
      <div class="d-flex align-items-center justify-content-between ">
        <b-form-select v-if="installers.length > 2" :value="selectedInstaller" @input="updateProp('selectedInstaller', $event)" :options="installers"
          class="calendar-select-view"></b-form-select>
      </div>
      <div class="d-flex align-items-center justify-content-between  ml-xl-auto">
        <h5 class="p-1 m-2 align-middle">{{ $t("general.completed") }}</h5>
        <b-form-checkbox switch size="lg" :checked="showCompleted" @input="updateProp('showCompleted', $event)" class=""></b-form-checkbox>
      </div>
      <div class="d-flex align-items-center justify-content-between flex-fill">
        <b-form-select :value="selectedView" @input="updateProp('selectedView', $event)" :options="viewOptions"
          class="calendar-select-view"></b-form-select>
      </div>
    </div>
  </div>
</template>
